<template>
  <div >
    <div class="prompt" v-if="showPrompt">
      <div>
        <img
          class="tipType"
          v-if="classStatus === 'success'"
          src="../../assets/svg/icon_success.svg"
        />
        <img
          class="tipType"
          v-if="classStatus === 'error'"
          src="../../assets/svg/icon_errorTip.svg"
        />
        {{ message }}
        <img
          @click="closeShow"
          class="closeImg"
          src="../../assets/svg/icon_close@3x.svg"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Prompt',
  data () {
    return {
      classStatus: 'success',
      message: '',
      showPrompt: true
    }
  },
  methods: {
    closeShow () {
      this.showPrompt = false
    },
    showSuccess (message) {
      this.message = message
      this.classStatus = 'success'
    },
    showError (message) {
      this.message = message
      this.classStatus = 'error'
    }
  }
}
</script>

<style lang="less" scoped>
.prompt {
  > div {
    padding: 20px 45px 20px 47px;
    font-size: 14px;
    position: fixed;
    top: 80px;
    z-index: 999;
    left:50%;
    transform: translateX(-50%);
    animation: showPromptAnimation 2s ease-out;
    animation-fill-mode: forwards;
    background: rgba(51, 51, 51, 0.94);
    box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.3);
    border-radius: 16px;
    color: #FFFFFF;
    font-family: "Barlow-bold";
    font-size: 16px;
    line-height: 19px;
    word-wrap: break-word;
  }
  .tipType {
    width: 22px;
    height: 22px;
    position: absolute;
    left: 15px;
    top: 50%;
    transform: translateY(-50%);
  }
  .closeImg {
    width: 22px;
    height: 22px;
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
  }
}
@keyframes showPromptAnimation {
  0% {
    opacity: 1;
  }
  5% {
    opacity: 1;
  }
  70% {
    opacity: 1;
  }
  99% {
    opacity: 1;
  }
  100% {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/plugins/prompt/Prompt.vue